import {
  Avatar,
  Button,
  Divider,
  Header,
  ProfileItem,
} from '@repo/ui/components';
import { LogOut, UserRoundCog } from 'lucide-react';
import { useAuth } from '@/providers/AuthContext';
import { css } from '@repo/themes/styled-system/css';
import { Link } from 'react-router';
import { ROUTES } from '@/shared/constants';
import { checkUserPermission } from '@/shared/lib/permissions-utils';
import { Permission } from '@/shared/model/permission';

const SiteHeader = () => {
  const { user, signedIn, logout } = useAuth();

  return (
    <Header.Container contained>
      <Header.Left asChild>
        <Link to={ROUTES.Home}>
          <img src='apipana_black.svg' width='40px' />
          <Header.Title>Employee Portal</Header.Title>
        </Link>
      </Header.Left>
      {signedIn && (
        <Header.Right>
          <ProfileItem.Root>
            <ProfileItem.Info>
              <h1>
                {user?.name} {user?.lastName}
              </h1>
              <h2 className={css({ color: 'orange.primary' })}>{user?.role}</h2>
            </ProfileItem.Info>
            <Avatar src='/default_profile.png' />
          </ProfileItem.Root>

          <Divider orientation='vertical' variant='compact' />

          <Header.Buttons>
            {user &&
              checkUserPermission(user, [Permission.CAN_MANAGE_USERS]) && (
                <Button variant='navBar'>
                  <Link to={ROUTES.Admin}>
                    <UserRoundCog aria-label='admin-panel' />
                  </Link>
                </Button>
              )}
            <Button variant='navBar' onClick={logout}>
              <LogOut />
            </Button>
          </Header.Buttons>
        </Header.Right>
      )}
    </Header.Container>
  );
};

export default SiteHeader;
